module.exports = __webpack_public_path__ + "img/ico10.d4120676.svg";